export default __webpack_public_path__ + "static/media/elf-01.172b8f30.jpg";